import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_PERSONALARCHIVE_MESSAGES_COUNT } from './../../shared/constants';
import { Observable, ReplaySubject } from 'rxjs';

enum MessagesType {
  All,
  UnRead
}

interface MessagesCountResponse extends ApiResponse {
  messagesCount: number;
  callIsSuccess: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessagesCountService extends ApiClientService {
  private unreadMessagesCount = new ReplaySubject<MessagesCountResponse>(null);
  private isLoaded = false;
  private isLoading = false;
  private cleanTimer = null;

  constructor(http: HttpClient) {
    super(http, AB_API_PERSONALARCHIVE_MESSAGES_COUNT);
  }

  getUnreadMessagesCount(): Observable<MessagesCountResponse> {
    if (this.isLoaded) {
      return this.unreadMessagesCount.asObservable();
    }

    if (!this.isLoading) {
      this.isLoading = true;

      this.get({ messagesType: MessagesType.UnRead }).subscribe(
        res => {
          this.isLoading = false;
          this.isLoaded = true;
          this.unreadMessagesCount.next({ ...res });
          this.startCleanTimer();
        },
        error => {
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
    }

    return this.unreadMessagesCount.asObservable();
  }

  getUnreadMessagesCountWithRefresh(): Observable<MessagesCountResponse> {
    this.cleanUnreadMessagesCount();

    return this.getUnreadMessagesCount();
  }

  cleanUnreadMessagesCount() {
    this.stopCleanTimer();
    this.isLoaded = false;
    this.unreadMessagesCount.complete();
    this.unreadMessagesCount = new ReplaySubject<MessagesCountResponse>(null);
  }

  private startCleanTimer() {
    this.cleanTimer = setTimeout(() => {
      this.cleanUnreadMessagesCount();
    }, 300000); // 5 minutes timeout
  }

  private stopCleanTimer() {
    clearTimeout(this.cleanTimer);
  }
}
